import angular from 'angular';
import uiRouter from 'angular-ui-router';
import auditprogramdrgchangesComponent from './auditprogramdrgchanges.component';

let auditprogramdrgchangesModule = angular.module('auditprogramdrgchanges', [
  uiRouter
])

.component('auditprogramdrgchanges', auditprogramdrgchangesComponent);

export default auditprogramdrgchangesModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditprogramdrgchanges/auditprogramdrgchanges.js